export default __webpack_public_path__ + "static/media/cancel.0939db00.svg";